import './banner.css';

export const Banner = ({ icon, message, colour }) => {
    return (
        <div className={`banner ${colour}`}>
            {icon && (
                <div className="icon">
                    <i className={`fa fa-${icon}`} />
                </div>
            )}
            <div className="message">{message}</div>
        </div>
    );
};

export default Banner;
